import { render } from "./ViewSubmittedCompliance.vue?vue&type=template&id=2588bc76"
import script from "./ViewSubmittedCompliance.vue?vue&type=script&lang=js"
export * from "./ViewSubmittedCompliance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__